<template>
  <FeeScheduleItemEditor
    v-if="showEdit"
    :mwc-id="getMwcIdForChild('edit-fee-schedule-view')"
    :schedule="schedule"
    :fee-schedule-types="feeScheduleTypes"
    :show-info-icons="settings.showInfoIcons"
    :is-program-based-mode="isProgramBasedMode"
    :program-options="programOptions"
    :currency-symbol="currencySymbol"
    @item-cancel-clicked="$emit('item-cancel-clicked', $event)"
    @item-save-clicked="$emit('item-save-clicked', $event)"
  >
  </FeeScheduleItemEditor>
  <FeeScheduleItemDisplay
    v-else
    :mwc-id="getMwcIdForChild('fee-schedule-item-view')"
    :schedule="schedule"
    :show-dot-menu="options.showDotMenu"
    :show-radio="options.showRadio"
    :editing-schedule-id="editingScheduleId"
    :fee-schedule-types="feeScheduleTypes"
    :show-info-icons="settings.showInfoIcons"
    :is-program-based-mode="isProgramBasedMode"
    :program-options="programOptions"
    :currency-symbol="currencySymbol"
    @schedule-selected="$emit('schedule-selected', $event)"
    @item-edit-clicked="$emit('item-edit-clicked', $event)"
    @delete-schedule="$emit('delete-schedule', $event)"
  ></FeeScheduleItemDisplay>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import FeeScheduleItemEditor from './FeeScheduleItemEditor';
import FeeScheduleItemDisplay from './FeeScheduleItemDisplay';

export default {
  name: 'hypo-fee-schedule-item',
  components: {
    FeeScheduleItemEditor,
    FeeScheduleItemDisplay,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    mwcId: {
      type: String,
      required: true,
    },
    config: {
      type: [String, Object],
      default: () => {},
    },
    currencySymbol: {
      type: String,
      default: '$',
    },
    showDotMenu: {
      type: Boolean,
      default: true,
    },
    showRadio: {
      type: Boolean,
      default: true,
    },
    schedule: {
      type: Object,
      default: () => {},
    },
    editingScheduleId: {
      type: Number,
      default: null,
    },
    feeScheduleTypes: {
      type: Array,
      default: () => [],
    },
    showInfoIcons: {
      type: Boolean,
      default: true,
    },
    isProgramBasedMode: Boolean,
    programOptions: Array,
  },
  data() {
    return {
      name: this.schedule.name,
    };
  },
  computed: {
    modifyingCurrentSchedule() {
      return this.editingScheduleId === this.schedule.id;
    },
    showEdit() {
      return this.modifyingCurrentSchedule;
    },
  },
  methods: {
    handleItemCancelClicked() {
      this.$emit('item-cancel-clicked');
    },
    handleSave() {
      this.$refs.editFeeScheduleView.validateInput().then(valid => {
        if (valid) {
          this.$emit('item-save-clicked', this.$refs.editFeeScheduleView.emitData());
        }
      });
    },
  },
};
</script>
